<template>
  <div class="job-info" v-loading="loadingJobInfo">
    <basic-form
      ref="jobInfo"
      title="Job Info"
      :mode="FormModes.SPARSE"
      :form-params="whatToShow"
    >
      <template v-slot:actions>
        <el-button
          size="small"
          type="primary"
          plain
          @click="editing = true"
          v-if="!editing && editable"
        >
          Edit
        </el-button>
        <el-button
          size="small"
          type="primary"
          plain
          @click="saveInfo"
          v-if="editing && editable"
        >
          Save
        </el-button>
        <el-button
          size="small"
          type="danger"
          plain
          @click="editing = false"
          v-if="editing && editable"
        >
          Cancel
        </el-button>
      </template>
    </basic-form>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
// models
import { JobInfoWrapUp } from '@/core/models/job'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// others
import { FormModes } from '@/core/configs/types'
// components
import BasicForm from '@/components/common/BasicForm.vue'
export default {
  name: 'JobInfo',
  components: { BasicForm },
  mixins: [pageJumps],
  props: {
    jobId: {
      type: String,
      required: true
    },
    job: {
      type: Object,
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      const a = JobInfoWrapUp(this.job)
      return a
    },
    editInfo() {
      const PalletInfoModifyForm = {}
      const form = cloneDeep(PalletInfoModifyForm)
      Object.values(form).forEach(one => {
        one.value = this.order[one.key]
      })
      return form
    }
  },
  mounted() {},
  watch: {
    jobInfo() {}
  },
  data() {
    return {
      FormModes,
      loadingJobInfo: false,
      editing: false
    }
  },
  methods: {
    editOrderInfo() {}
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';
</style>
